export const getUserCompletionStatus = (user: any) => {
  if (!user) return null;

  const profile = {
    province: !!user.province,
    city: !!user.city,
    gender: !!user.gender,
    cellphone: !!user.cellphone,
  };

  const profileCompleted = Object.values(profile).every(Boolean);


  const bank = {
    accountType: !!user?.bankAccount?.accountType,
    bank: !!user?.bankAccount?.bankCode,
    accountNumber: !!user?.bankAccount?.accountNumber,
    accountHolderName: !!user?.bankAccount?.accountHolderName,
    identificationType: !!user?.bankAccount?.identificationType,
    identificationNumber: !!user?.bankAccount?.identificationNumber,
  };

  const bankCompleted = Object.values(bank).every(Boolean);


  const hasAddress =
    Array.isArray(user.addresses) && user.addresses.length > 0;

  const addressCompleted = hasAddress;


  const documents = {
    bankCertificate: !!user.bankCertificate, 
    identityDocument: !!user.identityDocument, 
  };

  const documentsCompleted =
    documents.bankCertificate && documents.identityDocument;

  const tasks = [
    {
      key: "profile",
      label: "Perfil",
      completed: profileCompleted,
      items: profile,
    },
    {
      key: "bank",
      label: "Info bancaria",
      completed: bankCompleted,
      items: bank,
    },
    {
      key: "address",
      label: "Dirección",
      completed: addressCompleted,
      items: {
        hasAddress,
      },
    },
    {
      key: "documents",
      label: "Documentos",
      completed: documentsCompleted,
      items: documents,
    },
  ];


  const completedCount = tasks.filter((t) => t.completed).length;
  const total = tasks.length;

  const progress = Math.round((completedCount / total) * 100);

  return {
    tasks,
    summary: {
      completed: completedCount,
      total,
      progress,
      isComplete: progress === 100,
    },
  };
};